var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcqIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44579",
    "data-name": "Group 44579",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.591,
    height: 21.506,
    viewBox: "0 0 20.591 21.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89205",
    "data-name": "Path 89205",
    d: "M10.3,18.477a1.863,1.863,0,0,1-1.818-1.948v-.65a1.822,1.822,0,1,1,3.636,0v.65A1.863,1.863,0,0,1,10.3,18.477Z",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89206",
    "data-name": "Path 89206",
    d: "M7.114,20.75V20.3c0-1.245,2.05-1.818,3.182-1.818s3.182.562,3.182,1.808v.465",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89207",
    "data-name": "Path 89207",
    d: "M3.932,18.477a1.863,1.863,0,0,1-1.818-1.948v-.65a1.862,1.862,0,0,1,1.818-1.947A1.862,1.862,0,0,1,5.75,15.879v.65a1.863,1.863,0,0,1-1.818,1.948Z",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89208",
    "data-name": "Path 89208",
    d: "M.75,20.75V20.3c0-1.245,2.05-1.818,3.182-1.818s3.182.562,3.182,1.808v.465",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89209",
    "data-name": "Path 89209",
    d: "M16.659,18.477a1.863,1.863,0,0,1-1.818-1.948v-.65a1.822,1.822,0,1,1,3.636,0v.65a1.863,1.863,0,0,1-1.818,1.948Z",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89210",
    "data-name": "Path 89210",
    d: "M13.477,20.75V20.3c0-1.245,2.05-1.818,3.182-1.818s3.182.562,3.182,1.808v.465",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89211",
    "data-name": "Path 89211",
    d: "M16,12.3a6.6,6.6,0,0,0,.706-1.7l1.769-.411v-2.5l-1.769-.41A6.6,6.6,0,0,0,16,5.569l.96-1.541L15.2,2.265l-1.541.96a6.633,6.633,0,0,0-1.7-.706L11.542.75H9.048l-.41,1.769a6.64,6.64,0,0,0-1.706.706l-1.541-.96L3.628,4.028l.96,1.541a6.6,6.6,0,0,0-.706,1.706l-1.769.41v2.494l1.769.411a6.6,6.6,0,0,0,.706,1.7",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89212",
    "data-name": "Path 89212",
    d: "M12.568,8.932A2.273,2.273,0,1,1,10.3,6.659,2.273,2.273,0,0,1,12.568,8.932Z",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcqIcon);
export default __webpack_public_path__ + "static/media/mcq-icon.698260846ffbb95b032ebc32c2f6bbe7.svg";
export { ForwardRef as ReactComponent };